import { useEffect, useState } from "react";
import { makeSensorDataBySiteId } from "../utils/statsUtil";
import { fetchSensorCmlCounts } from "../../../api/statisticsApi";  
import { toast } from "react-toastify";


function useFetchSensorCmlCount() {

    const [Count, setCount] = useState({})

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        setLoading(true);

    
            fetchSensorCmlCounts().then((sensorData) => {
            // Process sensor count data
            console.log("Sensor Data:", sensorData);
            if (sensorData?.length > 0) {
                const processedSensorData = makeSensorDataBySiteId(sensorData);
                setCount(processedSensorData);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Cannot Fetch Sensor/CML Data");
            setError(err);
        }).finally(() => {
            setLoading(false);
        });
    }, []);

    return { Count, loading, error };
}

export default useFetchSensorCmlCount;